<template>
  <div class="kid-info">
    <div class="content">
      <div class="head">
        <img :class="['head-img', headImg.style]" :src="headImg.imgSrc" alt="">
      </div>
      <div class="wrapper">
        <div class="default-input">
          <span class="label-input">姓名：</span>
          <cube-input class="content-input" v-model="form.name" placeholder="请输入宝宝姓名或昵称" :maxlength="10"></cube-input>
        </div>
        <cube-validator v-model="valid.name" :model="form.name" :rules="rules.name" :messages="messages.name" ref="validName"></cube-validator>
      </div>
      <div class="wrapper">
        <div class="default-input">
          <span class="label-input">年龄：</span>
          <div @click="selectAge" style="height: 100%" class="content-input age">
            <cube-input v-model="form.age" placeholder="请选择宝贝年龄" readonly></cube-input>
            <img class="age-select-arrow" src="/images/evaluation_arrow_down.png" alt="">
          </div>
        </div>
        <cube-input v-model="form.birthday" class="valid-age"></cube-input>
        <cube-validator v-model="valid.birthday" :model="form.birthday" :rules="rules.birthday" :messages="messages.birthday" ref="validBirthday"></cube-validator>
      </div>
      <div class="wrapper">
        <div class="gender">
          <button @click="selectSex(1)" :class="boySexClass">
            <img src="/images/evaluation_boy.png" alt="">
            <span>男孩</span>
          </button>
          <button @click="selectSex(0)" :class="girlSexClass">
            <img src="/images/evaluation_girl.png" alt="">
            <span>女孩</span>
          </button>
        </div>
        <cube-validator v-model="valid.sex" :model="form.sex" :rules="rules.sex" :messages="messages.sex" ref="validSex"></cube-validator>
      </div>
      <button @click="submit" :class="['footer-btn', {'active': footerBtnActive}]">提交信息，进入评测</button>
      <p class="tip-text">正确填写宝宝信息，为您提供更精准的评测</p>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { formatMoment } from "@/utils/filter.js";
import { isNull, cloneDeep, isEmpty } from "lodash";
import { wechatShareEvaluationPage } from "@/mixins/wechatShare.js";
import moment from "moment";

export default {
  mixins: [wechatShareEvaluationPage],
  data() {
    return {
      form: {
        name: null,
        age: null,
        birthday: null,
        sex: null
      },
      valid: {
        name: "",
        age: null,
        birthday: null,
        sex: null
      },
      rules: {
        name: {
          required: true,
          type: "string",
          pattern: /^[0-9A-Za-z\u4e00-\u9fa5]{2,10}$/
        },
        birthday: {
          required: true,
          type: "number",
          custom: date => {
            if (date) {
              let arr = formatMoment(moment(+date));
              let now = formatMoment(moment());
              return !moment(arr).isAfter(now);
            }
          }
        },
        sex: {
          required: true,
          type: "number",
          custom: val => {
            return !isNull(val);
          }
        }
      },
      messages: {
        name: {
          pattern: "昵称为2-10位的有效字母、中文和数字"
        },
        birthday: {
          custom: "孩子的年龄范围为0~12岁"
        },
        sex: {
          custom: "请选择宝贝年龄"
        }
      },
      datePicker: null,
      sexOption: [
        {
          label: "男孩",
          value: 1
        },
        {
          label: "女孩",
          value: 0
        }
      ],
      initForm: null
    };
  },
  computed: {
    ...mapGetters({
      kidInfo: "auth/kidInfo",
      userInfo: "auth/userInfo",
      isNative: "externalInterface/isNative",
      isAuth:"auth/isAuth"
    }),
    minPickerDate() {
      let dateArr = formatMoment(moment().subtract(12, "year"));
      return new Date(dateArr[0], dateArr[1], dateArr[2]);
    },
    birthdayDate() {
      let dateValue = new Date();
      if (this.form && this.form.birthday) {
        let date = new Date(+this.form.birthday);
        let y = date.getFullYear(),
          m = date.getMonth(),
          d = date.getDate();
        dateValue = new Date(y, m, d);
      }
      return dateValue;
    },
    headImg() {
      let headImg = {
        style: "no-sex",
        imgSrc: "/images/sex_headImg.png"
      };
      if (this.kidInfo && this.form.sex == 1) {
        headImg = {
          style: "boy",
          imgSrc: "/images/boy_headImg.png"
        };
      } else if (this.kidInfo && this.form.sex == 0) {
        headImg = {
          style: "girl",
          imgSrc: "/images/girl_headImg.png"
        };
      }
      return headImg;
    },
    footerBtnActive() {
      let arr = ["name", "age", "birthday", "sex"];
      let flag = true;
      arr.map(item => {
        if (isNull(this.form[item])) {
          flag = false;
        }
        if (item != "sex" && !this.form[item]) {
          flag = false;
        }
      });
      return flag;
    },
    girlSexClass () {
      let sexClass = ['button_default']
      if (this.form.sex == 0) {
        sexClass = ['button_default', 'sex-girl']
      }
      return sexClass
    },
    boySexClass () {
      let sexClass = ['button_default']
      if (this.form.sex == 1) {
        sexClass = ['button_default', 'sex-boy']
      }
      return sexClass
    }
  },
  watch: {
    kidInfo: {
      immediate: true,
      handler: function(value) {
        // this.setLoading({ show: true });
        if (!isEmpty(value)) {
          // this.setLoading({ show: false });
          this.form = Object.assign({}, value);
          let { birthday } = this.form;
          let age = birthday ? moment(+birthday).format("YYYY-MM-DD") : null;
          this.$set(this.form, "age", age);
          this.initForm = {
            ...this.form
          };
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setLoading: "setLoadingShow"
    }),
    selectAge() {
      if (!this.datePicker) {
        this.datePicker = this.$createDatePicker({
          title: "请选择",
          min: this.minPickerDate,
          max: new Date(),
          value: this.birthdayDate,
          // value: new Date(),
          onSelect: this.selectHandle
        });
      }
      this.datePicker.show();
    },
    selectSex(value) {
      this.form.sex = value;
    },
    selectHandle(date, selectedVal, selectedText) {
      this.form.age = selectedVal.join("-");
      this.form.birthday = new Date(date).getTime();
    },
    validateForm() {
      return new Promise((resolve, reject) => {
        const p1 = this.$refs.validName.validate();
        const p2 = this.$refs.validBirthday.validate();
        const p3 = this.$refs.validSex.validate();
        Promise.all([p1, p2, p3]).then(validate => {
          let flag = validate.some(item => !item);
          resolve(flag);
        });
      });
    },
    async submit() {
      let flag = await this.validateForm();
      if (flag) return;
      let formChange = false;
      if (!isNull(this.initForm)) {
        Object.keys(this.initForm).map(key => {
          if (this.initForm[key] != this.form[key]) {
            formChange = true;
          }
        });
      } else {
        formChange = true;
      }
      if (!formChange) {
        this.$router.push("/evaluation/questionnaire");
        return;
      }
      let params = cloneDeep(this.form);
      params.phoneNum = this.userInfo.phoneNum;
      delete params.age;
      delete params.headImg;
      if (!params.detailId) {
        params.type = 0
      }
      this.setLoading({ show: true, text: "数据提交中" });
      this.$api
        .account_v1_user_detail_edit_post({
          data: {
            ...params
          }
        })
        .then(e => {
          this.setLoading({ show: false });
          if (e.code == 200) {
            this.$store.dispatch("auth/getUserInfo");
            this.$store.dispatch("externalInterface/updateAppUserData");
            this.$router.push("/evaluation/questionnaire");
          }
        });
    }
  }
};
</script>
<style scoped>
.kid-info {
  width: 100%;
  padding: 14px 10px 0;
  box-sizing: border-box;
  background: #2cd5b1;
  height: 100%;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 40px;
  background: #fff;
  border-radius: 30px 30px 0px 0px;
}
.head {
  width: 100%;
  height: 120px;
  text-align: center;
}
.head-img.girl {
  height: 77px;
  width: 232px;
}

.head-img.boy {
  width: 194px;
  height: 80px;
}
.head-img.no-sex {
  width: 264px;
  height: 41px;
}
.wrapper {
  margin-bottom: 30px;
  width: 100%;
}
.cube-validator {
  margin-top: 10px;
}
.content >>> .cube-validator-msg {
  text-align: center;
}
.content >>> .cube-validator-msg-def {
  color: #fe2c2a;
  font-size: 14px;
}
.default-input {
  width: 100%;
  height: 48px;
  border-radius: 30px;
  padding: 0 16px;
  background: rgba(247, 248, 250, 1);
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  color: #244352;
  position: relative;
}
.default-input .label-input {
  flex: 1;
}
.default-input .content-input {
  flex: 3;
}
.cube-input {
  width: 100%;
  background: rgba(247, 248, 250, 1);
  font-size: 16px;
  height: 100%;
}
.cube-input::after {
  border: none;
}
.default-input >>> .cube-input-field {
  padding: 0;
  color: #244352;
  font-size: 16px;
}
.age-select-arrow {
  width: 13px;
  height: 9px;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}
.valid-age {
  visibility: hidden;
  height: 0;
}
.gender {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.gender .button_default {
  padding: 7px 16px;
  height: 34px;
  border-radius: 30px;
  background: #f7f8fa;
  color: #244352;
  font-size: 16px;
  box-sizing: content-box;
  display: flex;
  align-items: center;
}
.gender .button_default > img {
  width: 30px;
  height: 30px;
  margin-right: 11px;
}
.button_default.sex-boy {
  color: #fff;
  background: #39b0ff;
}
.button_default.sex-girl {
  color: #fff;
  background: #ff789d;
}
.footer-btn {
  width: 100%;
  border-radius: 30px;
  height: 48px;
  background: #b4babc;
  color: #fff;
  font-size: 16px;
  margin-bottom: 32px;
}
.footer-btn.active {
  background: #469dff;
  color: #fff;
  box-shadow: 0px 2px 12px rgba(81, 138, 251, 0.6);
}
.tip-text {
  width: 100%;
  color: #6a92a4;
  font-size: 12px;
  text-align: center;
}
</style>

